import { Input } from '../Input';
import makeValidNumber from './makeValidNumber';
import makeString from './makeString';

type InputOnChange = NonNullable<Parameters<typeof Input>[0]['onChange']>;
export type PercentProps = Omit<Parameters<typeof Input>[0], 'type' | 'suffix' | 'onChange' | 'value'> & {
  value: number | null;
  onChange: (val: number | null, event?: Parameters<InputOnChange>[1]) => ReturnType<InputOnChange>;
  onFocus?: Parameters<typeof Input>[0]['onFocus'];
  suffix?: Parameters<typeof Input>[0]['suffix'];
};

const NumberInput: React.FC<PercentProps> = ({ onChange, value, ...props }) => {
  const handleChange: Parameters<typeof Input>[0]['onChange'] = (val, event) => {
    onChange(makeValidNumber(val), event);
  };
  return <Input {...props} value={makeString(value)} type="number" onChange={handleChange} />;
};

export default NumberInput;
